import { render, staticRenderFns } from "./Coaches.vue?vue&type=template&id=2b878381&scoped=true&"
import script from "./Coaches.vue?vue&type=script&lang=ts&"
export * from "./Coaches.vue?vue&type=script&lang=ts&"
import style0 from "./Coaches.vue?vue&type=style&index=0&id=2b878381&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b878381",
  null
  
)

export default component.exports